import { OspModal, OspToast } from "@ospweb/sdk-ui";
import { cn } from "utils";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Setting/DeactivateAccount";

const I18n = I18nUtil.createScoped(Translations);

interface DeactivateAccountModalProps {
  open: boolean;
  onClose: () => void;
}

export const DeactivateAccountModal = (props: DeactivateAccountModalProps) => {
  const { open, onClose } = props;

  const onDeactivateAccount = () => {
    OspToast.success({
      content: I18n.t("Deletion requested. 7 business days to process"),
    });
    onClose();
  };
  return (
    <OspModal
      open={open}
      onClose={onClose}
      footer={false}
      maskClosable={true}
      titleStyle={{
        minHeight: 0,
      }}
      containerClassName="!md:w-[400px] px-6 pt-6 pb-3 !md:rounded-[16px]"
      contentStyle={{
        backgroundColor: "var(--edgen-background_solid_secondary)",
        padding: 0,
        borderRadius: "16px",
        margin: 34,
      }}
      showClose={false}
      centered
      destroyOnClose
    >
      <div className="bg-background_solid_neutral_secondary flex flex-col gap-6">
        <div className="flex flex-col gap-2">
          <p className="headline_regular_s text-content_primary">
            {I18n.t("Confirm Permanent Account Deletion?")}
          </p>
          <p className="body_m text-content_secondary">
            {I18n.t(
              "Deletion in Progress Your account will be closed within 7 business days. In the meantime, you can still use your account as usual.",
            )}
          </p>
        </div>
        <div className="flex gap-2 justify-end">
          {/* Mk248jiPuc8z: 仅修描边 Confirm 的 ring token；Cancel 保持实心 primary */}
          <button
            type="button"
            data-openreplay-label={`DeactivateAccount · Button | ${I18n.t("Confirm")}`}
            className={cn(
              "button sm_button button_m ring-1 ring-border_inverse_transparent20 text-content_primary",
              "md:not-loading-and-disabled:hover:bg-background_white_overlay5",
            )}
            onClick={onDeactivateAccount}
          >
            {I18n.t("Confirm")}
          </button>
          <button
            type="button"
            data-openreplay-label={`DeactivateAccount · Button | ${I18n.t("Cancel")}`}
            className={cn("button sm_button primary_button button_m")}
            onClick={onClose}
          >
            {I18n.t("Cancel")}
          </button>
        </div>
      </div>
    </OspModal>
  );
};

export const DeactivateAccount = ({
  icon,
  onOpenDeactivateAccountModal,
}: {
  icon: React.ReactNode;
  onOpenDeactivateAccountModal: () => void;
}) => {
  return (
    <div className="flex items-center gap-2 p-2">
      {icon ?? null}
      <button
        aria-label="Deactivate Account Modal"
        data-openreplay-label={`Deactivate Account Modal Button | ${I18n.t("Deactivate account")}`}
        id="btn-deactivate-account-modal"
        className="body_medium_m text-content_primary"
        onClick={onOpenDeactivateAccountModal}
      >
        {I18n.t("Deactivate account")}
      </button>
    </div>
  );
};
